/**
 * DashboardNew.jsx - DEPRECATED
 * =============================
 * This file is kept for backward compatibility.
 * Please use /dashboard which renders DynamicDashboard from Blueprint.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';

// Redirect to new dashboard
const DashboardNew = () => {
  return <Navigate to="/dashboard" replace />;
};

export default DashboardNew;
